/**
 * RestaurantLogo Component
 * Displays the restaurant logo at the center of the chat screen
 * Shows light or dark version based on current theme
 */

import { useEffect, useState } from 'react'
import logoDark from '../../../assets/restaurant-logo-dark.png'
import logoLight from '../../../assets/restaurant-logo-light.png'

export function RestaurantLogo() {
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    // Check initial theme
    const checkTheme = () => {
      const root = document.documentElement
      const dataMode = root.getAttribute('data-mode')
      const hasDarkClass = root.classList.contains('dark')
      const mode = dataMode === 'dark' || (dataMode === null && hasDarkClass) ? 'dark' : 'light'
      setIsDarkMode(mode === 'dark')
    }

    checkTheme()

    // Watch for theme changes
    const observer = new MutationObserver(checkTheme)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-mode', 'class'],
    })

    // Also listen to media query changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = () => checkTheme()
    
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange)
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange)
    }

    return () => {
      observer.disconnect()
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange)
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(handleChange)
      }
    }
  }, [])

  return (
    <div className="absolute inset-0 flex items-start justify-center pointer-events-none pt-8">
      <div
        className="rounded-lg p-4"
        style={{
          border: '1.5px solid var(--border)',
          background: 'var(--card-bg)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          src={isDarkMode ? logoDark : logoLight}
          alt="Restaurant Logo"
          className="max-w-[280px] max-h-[280px] w-auto h-auto opacity-60"
          style={{
            objectFit: 'contain',
          }}
        />
      </div>
    </div>
  )
}
